import { Component, Input, OnInit } from "@angular/core";
import { AuthService, MetodoLogin } from "../../services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import {
  Form,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { IParametrosBackEnd } from "../../interfaces/IParametrosBackEnd";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-formulario-login",
  templateUrl: "./formulario-login.component.html",
  styleUrls: ["./formulario-login.component.css"],
})
export class FormularioLoginComponent implements OnInit {
  @Input() tipoConta;
  @Input() exibirLinkCadastro;
  @Input() parametros: IParametrosBackEnd;

  loading: boolean = false;
  ultimoLogin: MetodoLogin | null = null;
  forgotSuccess: boolean = false;
  forgotFail: boolean = false;

  showPassword = false;

  redirect: string = "";
  formdata: UntypedFormGroup;
  userName: UntypedFormControl;
  password: UntypedFormControl;
  loginData = {
    userName: "",
    password: "",
  };
  showLoginSenhaIncorreta: boolean = false;
  showLoginNaoConfirmado: boolean = false;
  step: string = "login";
  conta: string = "";
  mostrarLinkCadastro: boolean = true;
  origem: string = "";
  midiaCampanha: string = "";
  nomeCampanha: string = "";
  parametrosUrl: IParametrosBackEnd;
  nextjobtoken = "";
  nextjobvagaid = "";
  lpti: string = "";
  lpOrigem: string = "";
  siteUrl: string = "";

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    public actRouter: ActivatedRoute
  ) {
    this.authService.initFacebook();
    this.siteUrl = environment.serverUrl;

    this.actRouter.params.subscribe((params) => {
      if (params.redirect === "register") {
        this.router.navigate(["/paracandidatos/cadastrar"], {
          queryParamsHandling: "merge",
        });
      }

      this.parametrosUrl = {
        vagaId: params.vagaId,
        redirect: params.redirect,
        origem: this.origem,
        midiaCampanha: this.midiaCampanha,
        nomeCampanha: this.nomeCampanha,
      };
      //console.log("parametrosUrl", this.parametrosUrl);
    });

    this.actRouter.queryParams.subscribe((params) => {
      // Rota interna do front-reachr que o usuário estava tentando acessar quando caiu aqui
      // (ex: token expirado no meio de "/vaga/33715?abrirCampanha=extensao", vindo do
      // JwtInterceptor/app.component.ts do front-reachr) — guardamos em localStorage pra o
      // dashboard da empresa poder retomar a navegação depois do login, já que esse redirect
      // pra cá descarta a rota original (window.location.href para uma origem/app diferente).
      if (params["returnUrl"]) {
        localStorage.setItem("ls.returnUrlEmpresa", params["returnUrl"]);
      }

      // recebemos paramentros do login?
      if (
        params.idEmpresa != null &&
        params.nome != null &&
        params.email != null &&
        params.tipoConta != null
      ) {
        // redireciona para /cadatrar mantendo os parametros enviado
        this.router.navigate(["/cadastrar"], { queryParamsHandling: "merge" });
      } else if (params.tipoConta === "empresa" && params.email != null) {
        this.router.navigate(["/cadastrar"], { queryParamsHandling: "merge" });
      } else if (params.tipoConta === "candidato" && params.email != null) {
        this.router.navigate(["/paracandidatos/cadastrar"], {
          queryParamsHandling: "merge",
        });
      }

      if (params["nextjobtoken"]) {
        this.nextjobtoken = params["nextjobtoken"];
        this.redirect = "empresa/#/vaga-novo-fluxo/" + this.nextjobtoken;
        this.parametros = {
          redirect: this.redirect,
          vagaId: "",
          origem: "",
          midiaCampanha: "",
          nomeCampanha: "",
        };
        console.log("paramsNextJob", this.parametros);
      }
      if (params["nextjobvagaid"]) {
        this.nextjobvagaid = params["nextjobvagaid"];
        this.parametros = {
          redirect: "",
          vagaId: params["nextjobvagaid"],
          origem: "nextjob",
          midiaCampanha: "",
          nomeCampanha: "",
        };
        console.log("paramsNextJob", this.parametros);
      }
      if (params["vagaid"]) {
        if (params["vagaid"]) {
          this.parametros = {
            redirect: "",
            vagaId: params["vagaid"],
            origem: "reachr",
            midiaCampanha: "",
            nomeCampanha: "",
          };
        }
      }
      if (params["lpti"]) {
        this.lpti = params["lpti"];
        localStorage.setItem("ls.vagaId", this.lpti);
        this.redirect = "candidato/#/dashboard";
        this.parametros = {
          redirect: this.redirect,
          vagaId: "",
          origem: "",
          midiaCampanha: "",
          nomeCampanha: "",
        };
        console.log("paramsLPTI", this.parametros);
      }
      if (params["lpti"] && params["lp-origin"]) {
        this.lpti = params["lpti"];
        this.lpOrigem = params["lp-origin"];

        if (this.lpOrigem) {
          this.parametros = {
            redirect: "",
            vagaId: this.lpti,
            origem: this.lpOrigem,
            midiaCampanha: "",
            nomeCampanha: "",
          };
        } else {
          localStorage.setItem("ls.vagaId", this.lpti);
          this.redirect = "candidato/#/dashboard";
          this.parametros = {
            redirect: this.redirect,
            vagaId: "",
            origem: "",
            midiaCampanha: "",
            nomeCampanha: "",
          };
        }
        console.log("paramsLPTI", this.parametros);
      }
    });
  }

  ngOnInit(): void {
    this.ultimoLogin = this.authService.ultimoLogin();
    this.initForm();
    this.tipoConta = this.verificarAcessoLinkedin();
    this.conta = this.tipoConta;
    console.log(this.conta);
    this.mostrarLinkCadastro =
      this.exibirLinkCadastro != undefined ? this.exibirLinkCadastro : true;
    console.log(this.conta, this.parametros, this.mostrarLinkCadastro);
  }

  verificarAcessoLinkedin() {
    let linkedinRedirect = sessionStorage.getItem("linkedin-redirect");
    if (linkedinRedirect === null) return "empresa";
    sessionStorage.setItem("linkedin-redirect", "candidato");
    return "candidato";
  }

  initForm() {
    this.userName = new UntypedFormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
      ])
    );
    this.password = new UntypedFormControl(
      "",
      Validators.compose([Validators.required, Validators.minLength(6)])
    );

    this.formdata = new UntypedFormGroup({
      userName: this.userName,
      password: this.password,
    });
  }

  loginFacebook() {
    console.log("FLF: ", this.parametros);
    this.setredirect();
    if (this.parametros != undefined) {
      this.authService.loginFacebook(this.parametros);
    } else {
      this.authService.loginFacebook(null);
    }
  }

  setredirect() {
    if (this.redirect) {
      localStorage.setItem("ls.redirect", this.redirect);
    }
  }

  newLogin(userLogin) {
    this.showLoginSenhaIncorreta = false;
    this.setredirect();
    if (userLogin.valid) {
      this.loading = true;
      this.authService
        .login(
          userLogin.value,
          this.parametrosUrl.vagaId ? this.parametrosUrl : this.parametros
        )
        .subscribe(
          (resp) => {
            console.log(resp);
            this.loading = false;
          },
          (err) => {
            console.log(err);
            this.loading = false;
            if (
              err.error.error_description ==
              "The user name or password is incorrect."
            )
              this.showLoginSenhaIncorreta = true;
            if (err.error.error_description == "User did not confirm email.")
              this.showLoginNaoConfirmado = true;
            if (
              err.error_description == "The user name or password is incorrect."
            )
              this.showLoginSenhaIncorreta = true;
            if (err.error_description == "User did not confirm email.")
              this.showLoginNaoConfirmado = true;
          }
        );
    }
  }

  abrirFormularioEsqueceuSenha() {
    this.step = "forgot";
  }

  abrirFormularioLogin() {
    this.step = "login";
  }

  solicitarNovaSenha() {
    this.loading = true;
    this.forgotSuccess = false;
    this.forgotFail = false;
    let obj = {
      Email: this.userName.value,
    };

    this.http
      .post("https://api.reachr.com.br/api/account/ForgotPassword", obj, {})
      .subscribe((response) => {
        this.loading = false;
        this.forgotSuccess = true;
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.forgotFail = true;
      });
  }

  salvarParametros() {
    // this.tipoConta = "candidato";
    sessionStorage.setItem("linkedin-redirect", "candidato");
    // console.log(this.tipoConta, sessionStorage.getItem("linkedin-redirect"));
    console.log(this.parametros?.vagaId, this.parametrosUrl, this.parametros);
    localStorage.setItem(
      "parametros-vaga-login-linkedin",
      JSON.stringify(
        this.parametrosUrl.vagaId ? this.parametrosUrl : this.parametros
      )
    );
    // console.log(
    //   "params-linkedin: ",
    //   this.parametrosUrl.vagaId ? this.parametrosUrl : this.parametros
    // );
  }
}
